import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { Container, Form, Button, Card, Alert, Spinner } from 'react-bootstrap';
import { LogIn } from 'lucide-react';

async function hashPassword(password) {
  const msgBuffer = new TextEncoder().encode(password);
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [checkingAdmins, setCheckingAdmins] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem('adminAuth')) {
      navigate('/dashboard');
      return;
    }

    const checkAdmins = async () => {
      try {
        const snapshot = await getDocs(collection(db, 'admins'));
        if (snapshot.empty) {
          // Não existe nenhum administrador cadastrado.
          // Envia o usuário para a tela de acesso inicial (root).
          navigate('/primeiro-acesso');
          return;
        }
        setCheckingAdmins(false);
      } catch (err) {
        console.error(err);
        setCheckingAdmins(false);
      }
    };
    checkAdmins();
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const snapshot = await getDocs(collection(db, 'admins'));
      const hashed = await hashPassword(password);
      const match = snapshot.docs.find(
        (d) =>
          d.data().email === email.toLowerCase().trim() &&
          d.data().password === hashed
      );
      if (match) {
        localStorage.setItem(
          'adminAuth',
          JSON.stringify({ email: email.toLowerCase().trim(), ts: Date.now() })
        );
        navigate('/dashboard');
      } else {
        setError('E-mail ou senha inválidos.');
      }
    } catch (err) {
      setError('Erro ao verificar credenciais.');
    } finally {
      setLoading(false);
    }
  };

  if (checkingAdmins) {
    return (
      <div
        className="vh-100 d-flex align-items-center justify-content-center"
        style={{ backgroundColor: '#121212' }}
      >
        <Spinner animation="border" variant="warning" />
      </div>
    );
  }

  return (
    <div className="vh-100 d-flex align-items-center" style={{ backgroundColor: '#121212' }}>
      <Container>
        <div className="d-flex justify-content-center">
          <Card
            className="p-4 shadow-lg bg-dark text-white border-0"
            style={{ maxWidth: '400px', width: '100%' }}
          >
            <div className="text-center mb-4">
              <h2 style={{ color: '#FF8C00', fontWeight: 'bold' }}>ADMIN ACADEMIA</h2>
              <p className="text-muted">Acesse o painel de gestão</p>
            </div>

            {error && <Alert variant="danger">{error}</Alert>}

            <Form onSubmit={handleLogin}>
              <Form.Group className="mb-3">
                <Form.Label>E-mail</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="admin@email.com"
                  className="bg-secondary text-white border-0"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>Senha</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="******"
                  className="bg-secondary text-white border-0"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </Form.Group>

              <Button
                variant="warning"
                type="submit"
                className="w-100 fw-bold"
                style={{ backgroundColor: '#FF8C00', color: 'black' }}
                disabled={loading}
              >
                {loading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  <><LogIn size={18} className="me-2" /> ENTRAR</>
                )}
              </Button>
            </Form>

            <div className="text-center mt-3">
              <Button
                variant="link"
                className="text-decoration-none small p-0"
                style={{ color: '#FF8C00' }}
                onClick={() => navigate('/recuperar-senha')}
              >
                Esqueceu a senha?
              </Button>
            </div>
          </Card>
        </div>
      </Container>
    </div>
  );
};

export default Login;